module.exports = __webpack_public_path__ + "img/bk_02.9b5d16cd.png";